import type { ReactNode } from "react";

interface TestFormContainerProps {
  id?: string;
  title: string;
  statusSlot?: ReactNode;
  children: ReactNode | ReactNode[];
}

function TestFormContainer({ id, title, statusSlot, children }: TestFormContainerProps){
  return (
    <div>
      <div className="flex flex-row justify-between items-center p-4 border border-rmh-bluegray-400 bg-rmh-bluegray-100 rounded-t-lg">
        <label className="font-bold text-xl text-black" id={id ?? undefined}>{title}</label>
        {statusSlot}
      </div>
      <div className="border border-t-0 p-4 border-rmh-bluegray-500 rounded-b-lg flex-col">
        {children}
      </div>
    </div>
  )
}

export default TestFormContainer;